import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import Select from 'react-select';
import getLocale from '../../../i18n/getLocale';


class ScheduleGradeAircraftLineAircraft extends Component {
  constructor(props) {
    super(props);
    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      sga_id: this.props.sga_id,
      sgas_id: this.props.sgas_id,
      aircrafts_list: this.props.aircrafts_list,
      aircraft_name: this.props.aircraft_name,
      aircraft_id: this.props.aircraft_id,
      edit_mode: this.props.edit_mode,
      show_select: 0,
    };

    this.locale = getLocale();

    this.toggleSelect = this.toggleSelect.bind(this);
    this.escFunction = this.escFunction.bind(this);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if((this.state.loaded === 0 && typeof newProps.aircraft_id !== 'undefined') || (this.state.loaded === 1 && newProps.updated === 1)) {
      if(newProps.aircraft_name === null) {
        this.setState({aircraft_name: 'AER.'});
      } else {
        this.setState({aircraft_name: newProps.aircraft_name});
      }
      if(newProps.aircraft_id === 0) {
        this.setState({aircraft_id: null});
        this.setState({aircraft_name: 'AER.'});
      } else {
        this.setState({aircraft_id: newProps.aircraft_id});
      }
      this.setState({
        sga_id: newProps.sga_id,
        sgas_id: newProps.sgas_id,
        aircrafts_list: newProps.aircrafts_list,
        loaded: 1,
        show_select: 0,
        modal: false,
      });
    }
    this.setState({edit_mode: newProps.edit_mode});
  }

  componentDidMount() {
    document.addEventListener("keydown", this.escFunction, false);
  }

  // Handlers
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = this.state.aircraft_id;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
    if (event !== null && this.state.show_select === 1) {
      this.props.changeAircraftSingle(event.value, this.state.sgas_id)
    }
  }

  // exibe o select
  toggleSelect() {
    if(this.state.edit_mode) {
      this.setState({show_select: 1});
    }
  }

  // Fecha select quando pressionada a tecla esc
  escFunction(event){
    if(event.keyCode === 27) {
      this.setState({show_select: 0});
    }
  }

  render() {
    var self = this;
    var alert_level = self.props.alert_level;
    if(self.props.alert_level === null) alert_level = 'default';
    return (
  <div className="text-center" onClick={this.toggleSelect}>
    <RequestApi ref={'request_api'} handleLoaded={this.props.handleLoaded} />

    {(self.state.show_select === 0) ?
      <div>
        {self.state.aircraft_name}
        <br />
        {!self.state.edit_mode && <button className={'btn btn-' + alert_level + ' btn-xs'} onClick={() => self.props.generateAircraftAlerts(self.state.sga_id)}><i className="fa fa-warning"></i></button>}
      </div>
    :
      <Select
        className="form-field-name"
        name="aircraft_id"
        value={self.state.aircraft_id}
        searchable={true}
        placeholder={this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.tabelaPrincipal.placeholder.AER}
        onChange={self.handleSelectChange.bind(self, 'aircraft_id')}
        options={self.state.aircrafts_list}
        menuPortalTarget={document.body}
        menuPosition={'fixed'}
        styles={{
          // Fixes the overlapping problem of the component
          menuPortal: provided => ({ ...provided, zIndex: 9999 }),
          menu: provided => ({ ...provided, zIndex: 9999 })
        }}
      />
    }
  </div>
    );
  }
}

export default ScheduleGradeAircraftLineAircraft;



// WEBPACK FOOTER //
// ./src/Components/ScheduleGrades/Elements/ScheduleGradeAircraftLineAircraft.js